import numeral from 'numeral';

numeral.register('locale', 'fr_FR', {
  delimiters: {
    thousands: ',',
    decimal: '.',
  },
  abbreviations: {
    thousand: 'K',
    million: 'MM',
    billion: 'BN',
    trillion: 'TN',
  },
  currency: {
    symbol: '$',
  },
});

numeral.locale('fr_FR');
